import { createContext, useCallback, useContext, useState } from "react";
import { CTA_CONFIG } from "@/config/cta";
import { ComingSoonModal } from "./ComingSoonModal";

const CtaContext = createContext({ openCta: () => {} });

export const CtaProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [source, setSource] = useState("modal");

  const openCta = useCallback((src) => {
    if (CTA_CONFIG.mode === "link" && CTA_CONFIG.href) {
      window.location.href = CTA_CONFIG.href;
      return;
    }
    setSource(src || "modal");
    setOpen(true);
  }, []);

  return (
    <CtaContext.Provider value={{ openCta }}>
      {children}
      <ComingSoonModal open={open} onOpenChange={setOpen} source={source} />
    </CtaContext.Provider>
  );
};

export const useCta = () => useContext(CtaContext);
